import { render, staticRenderFns } from "./SuccessPaymentTab.vue?vue&type=template&id=a76d7068&scoped=true&"
import script from "./SuccessPaymentTab.vue?vue&type=script&lang=ts&"
export * from "./SuccessPaymentTab.vue?vue&type=script&lang=ts&"
import style0 from "./SuccessPaymentTab.vue?vue&type=style&index=0&id=a76d7068&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a76d7068",
  null
  
)

export default component.exports